// src/menu-items/platform.jsx
// Platform-level (superadmin-only) menu. `superadminOnly` is honored by the nav filter
// (Navigation/index.jsx) — it is an Auth claim, NOT a role, so the `admin` role does not see it.
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';

const platform = {
  id: 'group-platform',
  title: 'Platform',
  type: 'group',
  superadminOnly: true,
  children: [
    {
      id: 'brands',
      title: 'Brands',
      type: 'item',
      url: '/admin/brands',
      icon: () => <StorefrontIcon sx={{ fontSize: 21 }} />,
      superadminOnly: true
    },
    {
      id: 'new-brand-setup',
      title: 'New Brand Setup',
      type: 'item',
      url: '/admin/brands/new',
      icon: () => <AddBusinessIcon sx={{ fontSize: 21 }} />,
      superadminOnly: true
    },
    {
      id: 'ticketed-events',
      title: 'Ticketed Events',
      type: 'item',
      url: '/admin/ticketed-events',
      icon: () => <ConfirmationNumberIcon sx={{ fontSize: 21 }} />,
      superadminOnly: true
    }
  ]
};

export default platform;
